import { inject } from '@angular/core';
import { Ticket } from '../data/ticket.model';
import { TicketService } from '../services/ticket.service';
import { ResolveFn } from '@angular/router';

export const createTicketDefaultValuesResolver: ResolveFn<Ticket | null> = async (
  route
) => {
  const ticketService = inject(TicketService);

  return await ticketService.getFormDefaultValues();
};
